import Field from 'components/Form/Field';
import TooltipWrapper from 'components/Tooltip';
import {useTooltip} from 'components/Tooltip/hook';
import Value from 'components/Value';
import {FC} from 'react';
import {t} from 'ttag';

import {FragmentElement, FragmentVariable} from './types';
import {isFragmentText, isFragmentVariable} from './utils';

const RenderVariable = (fragment: FragmentVariable) => {
    const {setTooltipRef} = useTooltip();
    return (
        <span className="bg-green-300 text-green-900" ref={setTooltipRef}>
            {fragment.finalValue}
        </span>
    );
};

const RenderFragmentElement = (fragment: FragmentElement) => {
    if (isFragmentText(fragment)) {
        return <div key={fragment.text}>{fragment.text}</div>;
    }
    if (isFragmentVariable(fragment)) {
        return (
            <div key={fragment.finalValue}>
                <TooltipWrapper message={fragment.name}>
                    <RenderVariable {...fragment} />
                </TooltipWrapper>
            </div>
        );
    }
    return null;
};

type TextFragmentProps = {
    message: FragmentElement[];
    subject: FragmentElement[];
    suffix?: string;
};

const TextFragment: FC<TextFragmentProps> = ({message, subject, suffix}) => {
    return (
        <>
            <Field label={t`Subject`} type="value">
                <Value
                    value={{
                        type: 'custom',
                        value: (
                            <div className="whitespace-pre-line">
                                {subject.map(RenderFragmentElement)}
                            </div>
                        ),
                    }}
                />
            </Field>
            <Field label={t`Message`} type="value">
                <Value
                    value={{
                        type: 'custom',
                        value: (
                            <div className="whitespace-pre-line">
                                {message.map(RenderFragmentElement)}
                            </div>
                        ),
                    }}
                />
            </Field>
            <Field label={''} type="value">
                <Value
                    value={{
                        type: 'string',
                        value: suffix || '',
                    }}
                />
            </Field>
        </>
    );
};

export default TextFragment;
